export default {
  state: {
    // 控制菜单是否展开
    isExpend: JSON.parse(localStorage.getItem("VUE_APP_IsExpend")),
  },
  mutations: {
    setIsExpend(state) {
      state.isExpend = !state.isExpend;
      localStorage.setItem("VUE_APP_IsExpend", JSON.stringify(state.isExpend));
    },
  },
};
